import AbstractStorage from './abstract.storage'

class Store {
    constructor({key, lifeTime = '30M'}) {
        this.key = key
        this.lifeTime = lifeTime
        this.sProxy = new AbstractStorage()
        this.initialize()
    }

    setOption(options) {
        // this = { ...this, ...options }
    }

    assert() {
        if (this.key === null) {
            throw 'no override key property'
        }
        if (this.sProxy === null) {
            throw 'no override sProxy property'
        }
    }

    initialize(opts) {
        
        this.setOption(opts)
        this.assert()
    }

    _getLifeTime() {
        let timeout = 0
        let str = this.lifeTime
        let unit = str.charAt(str.length - 1)
        let num = str.substring(0, str.length - 1)
        const Map = {
            D: 86400,
            H: 3600,
            M: 60,
            s: 1
        }
        if (typeof unit === 'string') {
            unit = unit.toUpperCase()
        }
        timeout = num
        if (unit) timeout = Map[unit]

        //单位为毫秒
        return num * timeout * 1000
    }

    set(value, sign) {
        //获取过期时间
        let timeout = new Date()
        timeout.setTime(timeout.getTime() + this._getLifeTime())
        this.sProxy.set(this.key, value, timeout, sign)

    }

    //设置单个属性
    setAttr(name, value, sign) {
        let key, obj

        if (name === Object(name)) {
            for (let key in name) {
                if (name.hasOwnProperty(key)) this.setAttr(key, name[key], value)
            }
            return
        }

        if (!sign) sign = this.getSign()
        //获取当前对象
        obj = this.get(sign) || {}
        if (!obj) return

        obj[name] = value
        this.set(obj, sign)
    }

    getSign() {
        return this.sProxy.getSign(this.key)
    }

    remove() {
        this.sProxy.remove(this.key)
    }

    removeAttr(attrName) {
        let obj = this.get() || {}

        if (obj[attrName]) {
            delete obj[attrName]
        }

        this.set(obj)
    }

    get(sign) {
        let result = [], isEmpty = true, a

        const obj = this.sProxy.get(this.key, sign)
        const type = typeof obj

        const o = { 'string': true, 'number': true, 'boolean': true }
        if (o[type]) return obj

        if (Array.isArray(obj)) {
            const len = obj.length
            for (let i = 0; i < len; i++) {
                result[i] = obj[i]
            }
        } else if (obj === Object(obj)) {
            result = obj
        }

        for (a in result) {
            isEmpty = false
            break
        }

        return !isEmpty ? result : null

    }

    getAttr(attrName, tag) {
        const obj = this.get(tag)
        let attrVal = null

        if (obj) {
            attrVal = obj[attrName]
        }

        return attrVal
    }

}

export default Store